// extracted by css-extract-rspack-plugin
module.exports =  {"no-students":"UserSelector-yHtz__no-students","answers-completion":"UserSelector-qlwU__answers-completion"};